import script from "./GettingStartedChecklist.vue?vue&type=script&setup=true&lang=js"
export * from "./GettingStartedChecklist.vue?vue&type=script&setup=true&lang=js"

import "./GettingStartedChecklist.vue?vue&type=style&index=0&id=12e8eb0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e8eb0c"]])

export default __exports__